export default __webpack_public_path__ + "img/6c591687712a0fe41cf8e8cfb3871bba.png";